module.exports = __webpack_public_path__ + "img/chemine.0a376ef7.jpeg";